/**
 * InputPeriod
 */
import { styled } from '@mui/material/styles';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { ReactNode } from 'react';
import { FieldLabel } from 'src/presentations/components/molecules/fields/FieldLabel';

interface IInputPeriodProps {
  label?: ReactNode;
  placeholder?: any;
  name: string;
}

export interface IDatePickerProps<T = any> extends DatePickerProps<T> {
  name: string;
}

const StyledDateTimePicker = styled(DateTimePicker)({
  width: '100%',
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    backgroundColor: '#F5F6FA',
    borderColor: '#BFBFBF',
  },
  '& .MuiInputBase-input': {
    paddingTop: '12px',
    paddingBottom: '12px',
  },
});

export const RhfMuiDateTimePicker: React.FC<IInputPeriodProps> = ({ label }) => (
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <FieldLabel label={label}>
      <div className='flex items-center gap-8'>
        <p className='text-10 xl:text-12 leading-14 xl:leading-16 mb-8 text-blue_grey-80'>Start Date</p>
        <StyledDateTimePicker />
      </div>
    </FieldLabel>
  </LocalizationProvider>
);
